import { useMemo } from 'react';

import { useGetExpatLovs } from '../proposal.slice';

export function useExpatLovs(isExpat: boolean) {
  const { data } = useGetExpatLovs({ skip: !isExpat });

  return useMemo(() => {
    const gendersRaw = data?.Gender?.enumValues ?? [];
    const genders: string[] = gendersRaw
      .map((g) => g?.name)
      .filter((s): s is string => Boolean(s));

    const medicalClasses = data?.planConfig?.getMedicalClasses ?? [];
    const nationalities = data?.core?.getNationalities ?? [];
    const occupationClasses = data?.core?.getOccupationClass ?? [];
    const occupations = data?.core?.getOccupationList ?? [];

    const medicalClassesRec: Record<string, string> = {};
    medicalClasses.forEach((m) => {
      if (!m) return;
      const label = m.title ?? m.code ?? '';
      if (m.id) medicalClassesRec[m.id] = label;
    });

    const nationalitiesRec: Record<string, string> = {};
    nationalities.forEach((n) => {
      if (!n) return;
      const label = n.title ?? n.code ?? '';
      if (n.id) nationalitiesRec[n.id] = label;
    });

    const occupationClassesRec: Record<string, string> = {};
    occupationClasses.forEach((o) => {
      if (!o) return;
      const label = o.title ?? o.code ?? '';
      if (o.id) occupationClassesRec[o.id] = label;
    });

    // Profession dropdown options (id -> "Description Arabic") and the map used
    // to auto-derive the read-only Occupation Class from the chosen Profession.
    const occupationListRec: Record<string, string> = {};
    const occupationToClass: Record<string, string> = {};
    occupations.forEach((o) => {
      if (!o?.id) return;
      const description = o.description ?? '';
      const arabic = o.arabic ?? '';
      occupationListRec[o.id] = [description, arabic]
        .filter(Boolean)
        .join(' ')
        .trim();

      const classId = o.occupationClassId ?? o.occupationClass?.id;
      if (classId != null) occupationToClass[o.id] = String(classId);
    });

    return {
      genders, // e.g. ["MALE","FEMALE"]
      nationalities: nationalitiesRec, // id -> label
      occupationClasses: occupationClassesRec, // id -> label
      medicalClasses: medicalClassesRec, // id -> label
      occupationList: occupationListRec, // id -> "Description Arabic"
      occupationToClass // occupation id -> occupation class id
    };
  }, [data]);
}
